import React, { useState, useEffect } from 'react';
import api from '../api/client';

// Pickup points coordinates
const PICKUP_POINTS = [
  { name: 'Cyber Parc Arsat Moulay Abdeslam', lat: 31.6265, lng: -7.9964, url: 'https://maps.app.goo.gl/34b3T7G9UetBqcVk9' },
  { name: 'Bab Agnaou', lat: 31.6195, lng: -7.9890, url: 'https://maps.app.goo.gl/ypxCv38bfvv23wFXA' },
  { name: 'Hotel Amani', lat: 31.6310, lng: -7.9940, url: 'https://maps.app.goo.gl/Zo4Fkb5SUBhU81mj9' },
  { name: 'Cinema Colisee', lat: 31.6340, lng: -7.9980, url: 'https://maps.app.goo.gl/HMs1KPHzMi6FCMSq9' },
  { name: 'Al Kabir Hotel', lat: 31.6380, lng: -8.0020, url: 'https://maps.app.goo.gl/spAaVov76gJzbpdK6' },
  { name: 'Pharmacie Laboratoire Majorelle', lat: 31.6360, lng: -8.0050, url: 'https://maps.app.goo.gl/W1dJCd5fPBEdwdN48' }
];

function Map() {
  const [geoStatus, setGeoStatus] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGeo();
    const interval = setInterval(loadGeo, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, []);

  const loadGeo = async () => {
    const data = await api.geoStatus();
    if (data?.active_checkins) setGeoStatus(data.active_checkins);
    setLoading(false);
  };

  // Group guides by pickup point
  const guidesAtPoints = {};
  geoStatus.forEach(c => {
    if (!guidesAtPoints[c.pickup_point]) guidesAtPoints[c.pickup_point] = [];
    guidesAtPoints[c.pickup_point].push(c);
  });

  return (
    <div className="animate-in">
      <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '16px', marginBottom: '12px', border: '1px solid #333' }}>
        <div style={{ fontSize: '14px', fontWeight: 700, marginBottom: '4px' }}>🗺 Carte des Guides</div>
        <div style={{ fontSize: '11px', color: '#888' }}>Position en temps réel · Actualisation auto 30s</div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '30px' }}><div className="spinner" style={{ margin: '0 auto' }}></div></div>
      ) : (
        <>
          {/* Visual Map - Simple representation */}
          <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '16px', marginBottom: '12px', border: '1px solid #333' }}>
            {PICKUP_POINTS.map(point => {
              const guidesHere = guidesAtPoints[point.name] || [];
              const hasGuides = guidesHere.length > 0;

              return (
                <div key={point.name} style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  padding: '12px 0', borderBottom: '1px solid #2a2a2a'
                }}>
                  <div style={{
                    width: '12px', height: '12px', borderRadius: '50%',
                    background: hasGuides ? '#10B981' : '#444',
                    boxShadow: hasGuides ? '0 0 8px rgba(16,185,129,0.5)' : 'none',
                    animation: hasGuides ? 'pulse 2s infinite' : 'none'
                  }}></div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: 500, color: hasGuides ? '#fff' : '#888' }}>
                      📍 {point.name}
                    </div>
                    {hasGuides && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
                        {guidesHere.map((g, i) => (
                          <span key={i} style={{
                            background: '#064E3B', color: '#6EE7B7', padding: '2px 8px',
                            borderRadius: '8px', fontSize: '10px', fontWeight: 600
                          }}>
                            {g.guide_name} · {g.checked_in_at?.substring(11, 16)}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <a href={point.url} target="_blank" rel="noreferrer" style={{
                    background: '#2a2a2a', border: '1px solid #444', borderRadius: '6px',
                    padding: '4px 8px', fontSize: '10px', color: '#60A5FA', textDecoration: 'none'
                  }}>Maps</a>
                </div>
              );
            })}
          </div>

          {/* Summary */}
          <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '14px', border: '1px solid #333' }}>
            <div style={{ fontSize: '12px', color: '#888', textAlign: 'center' }}>
              {geoStatus.length} guide(s) en position · {Object.keys(guidesAtPoints).length} point(s) actif(s)
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Map;
